import * as React from "react";
import { forwardRef } from "react";
const SvgProfileLinkIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 5, width: 14, height: 14, rx: 7, stroke: "#1B2C5C", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 6.75, y: 1.5, width: 11.375, height: 11.375, rx: 5.6875, stroke: "#1B2C5C", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgProfileLinkIcon);
export { ForwardRef as ReactComponent };
